/**
 * Modelos e tipos do SDK Analytics GA4 do Itaú — jornada Onboarding Agro PF.
 *
 * Formaliza o contrato de eventos e parâmetros aceitos pelo SDK Analytics Web,
 * alinhado às boas práticas da skill `sdk-analytics-ga4` e TechSpec 15213.
 *
 * @see {@link https://portaltoolkitanalytics.cloud.itau.com.br/techspecGa4?documento=15213}
 */

/**
 * Tipos de evento suportados pelo SDK Analytics GA4 do Itaú.
 *
 * NOTA: Usar `enum` regular (não `const enum`) — incompatível com
 * `isolatedModules: true` do Angular 16 com ngx-build-plus.
 */
export enum AnalyticsEventType {
  SCREEN_VIEW = 'screen_view',
  CLICK = 'click',
}

/**
 * Parâmetros de eventos reconhecidos pelo SDK Analytics GA4 do Itaú.
 *
 * O índice de string `[key: string]: unknown` permite extensibilidade futura
 * sem quebrar tipagem — usa `unknown` em vez de `any` conforme skill `angular-developer`.
 */
export interface IAnalyticsParams {
  custom_path: string;
  detail?: string;
  implementation_team?: string;
  [key: string]: unknown;
}
